
<div>
    <v-row class="no-frame lm-border pa-3 mb-1 mt-0 pt-0">
        <v-col class="no-frame">
            <v-text-field
                v-model="filter.text"
                hide-details
                @input="onChanged"
            />
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame mb-1 lm-border pa-3 pt-1 pb-1" v-if="showMainTypes">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "für Liftmanagement"
                        v-model = "filter.lim"
                        class   = "mt-0 pr-2"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                </v-col>
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   ="für Ereignisse"
                        v-model = "filter.inc"
                        class   = "mt-0 pl-4"
                        :ripple = "false"
                        @change = "onChanged"
                        style="width: 150px;"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>

    <v-row class="no-frame lm-border pa-3 pt-1 pb-0 mb-0">
        <v-col class="no-frame v-flex">
            <v-checkbox
                label   = "aktiv"
                v-model = "filter.active"
                class   = "mt-0 pr-2"
                :ripple = "false"
                @change = "onChanged"
                hide-details
            />
        </v-col>
        <v-col class="no-frame v-flex">
            <v-checkbox
                label   = "inaktive"
                v-model = "filter.inactive"
                class   = "mt-0 pl-4"
                :ripple = "false"
                @change = "onChanged"
                style="width: 150px;"
                hide-details
            />
        </v-col>
    </v-row>
</div>
